import store from "@src/redux/store";
import { REQUEST_ROLE_MAPPING } from "../constants/router-constants";

const getAuthRoleFromStore = () => {
  try {
    const state = store.getState?.();
    return state?.auth?.role;
  } catch (e) {
    return undefined;
  }
};

export const checkRole = (role, p) => {
  if (!role) {
    const authRole = getAuthRoleFromStore();
    if (authRole) role = authRole;
  }
  if (role != null && role.includes(p)) {
    return true;
  }
  return false;
};

export const checkListRole = (role, pArr) => {
  if (!role) {
    const authRole = getAuthRoleFromStore();
    if (authRole) role = authRole;
  }

  if (role != null) {
    for (let i = 0; i < pArr.length; i++) {
      if (role.includes(pArr[i])) {
        return true;
      }
    }
  }
  return false;
};

export const checkRequestRole = (role, request) => {
  let dataRole = null;
  for (let key in REQUEST_ROLE_MAPPING) {
    if (request && request.indexOf(key) != -1) {
      dataRole = REQUEST_ROLE_MAPPING[key];
      break;
    }
  }
  if (!dataRole || !role || role.length == 0) {
    return false;
  }
  if (dataRole.length == 0) {
    return true;
  } else {
    for (let i = 0; i < dataRole.length; i++) {
      if (role.includes(dataRole[i])) {
        return true;
      }
    }
  }
  return false;
};
